import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, ArrowRight, AlertCircle } from "lucide-react";

export const Route = createFileRoute("/ai/clinical-notes")({
  component: ClinicalNotesPage,
});

function ClinicalNotesPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <FileText className="h-5 w-5" /> Notes cliniques assistées
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Génération assistée de notes SOAP · brouillon uniquement</p>
      </div>

      <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 flex items-start gap-2 text-sm">
        <AlertCircle className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
        <div className="text-amber-200/90">
          <strong>Note IA :</strong> les notes générées sont des brouillons. Le clinicien doit relire, corriger et signer.
        </div>
      </div>

      <Card>
        <CardContent className="p-6 text-sm text-muted-foreground">
          Le module de génération assistée est intégré à la consultation. Pendant la consultation, vous pouvez demander un brouillon SOAP à partir des données brutes.
          <Button asChild className="mt-4">
            <Link to="/consultation">Ouvrir Consultation <ArrowRight className="h-3.5 w-3.5 ml-1" /></Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
